(function () {
  "use strict";

  var DATA = window.WISNIOWSKI_PRICE_DATA;
  if (!DATA) return;

  var I18N = {
    fr: {
      title: "Configurez votre portail WIŚNIOWSKI",
      intro: "Choisissez un modèle, ses dimensions et ses options pour obtenir immédiatement une estimation TVAC.",
      productHeading: "Type de produit", modelHeading: "Modèle et dimensions", optionsHeading: "Finition et options",
      contactHeading: "Recevoir un devis précis", contactCopy: "Envoyez votre configuration à Facadeck. Nous vérifierons les dimensions et vous contacterons avec le prix définitif.",
      material: "Matériau", collection: "Collection", model: "Modèle", width: "Largeur entre poteaux", height: "Hauteur du battant",
      finish: "Finition / couleur", motor: "Motorisation", installation: "Ajouter l'installation", previewHint: "Photo indicative du produit sélectionné",
      name: "Nom et prénom", phone: "Téléphone", email: "E-mail", postcode: "Code postal du chantier", message: "Informations supplémentaires",
      submit: "Demander un devis précis", privacy: "En envoyant ce formulaire, vous acceptez d'être contacté au sujet de votre projet.",
      estimate: "Estimation indicative", vatIncluded: "TVAC 21 %", freeTransport: "Transport gratuit en Belgique",
      disclaimer: "Cette estimation n'est pas une offre contractuelle. Le prix final est confirmé après vérification technique et prise de mesures.",
      success: "Merci. Votre configuration a bien été envoyée.", sliding: "Portail coulissant", double: "Portail à deux battants", wicket: "Portillon",
      steel: "Acier", aluminium: "Aluminium", base: "Produit", colourExtra: "Supplément couleur", automation: "Motorisation", accessories: "Options",
      transport: "Transport", free: "Gratuit", installed: "Installation", noMotor: "Sans motorisation", withMotorAwso: "Avec motorisation – AWso 2025 Pro", withMotorSomfy: "Avec motorisation – Somfy Ixengo L 3S io", standard: "RAL standard - inclus",
      nonstandard: "RAL non standard (+10 %)", special: "Couleur spéciale (+15 %)", home2: "Home Inclusive 2.0 (+15 %)",
      extraRemote: "Télécommande supplémentaire", reflectedCells: "Photocellules réfléchissantes", gsm: "Commande GSM 4G",
      gateWifi: "Module WIŚNIOWSKI GATE Wi-Fi", codeLock: "Clavier à code extérieur", cardReader: "Lecteur de proximité",
      fingerprint: "Lecteur d'empreintes BioKey", safetyEdge: "Système de sécurité avec barre palpeuse", magneticLock: "Serrure électromagnétique",
      closer: "Ferme-portail hydraulique Locinox LION – fermeture automatique", electricLock: "Serrure électrique verticale BFT",
      selectOption: "Sélectionnez", dimensionUnavailable: "Dimension non tarifée - demandez un devis", configuration: "Configuration",
      installationIncluded: "Prix fixe TVAC", summaryProduct: "Produit", summaryDimensions: "Dimensions", summaryFinish: "Finition", summaryTotal: "Total estimé"
    },
    nl: {
      title: "Configureer uw WIŚNIOWSKI-poort",
      intro: "Kies een model, afmetingen en opties en bekijk onmiddellijk een indicatieve prijs inclusief btw.",
      productHeading: "Type product", modelHeading: "Model en afmetingen", optionsHeading: "Afwerking en opties",
      contactHeading: "Ontvang een nauwkeurige offerte", contactCopy: "Stuur uw configuratie naar Facadeck. Wij controleren de afmetingen en nemen contact op met de definitieve prijs.",
      material: "Materiaal", collection: "Collectie", model: "Model", width: "Breedte tussen de palen", height: "Hoogte van de vleugel",
      finish: "Afwerking / kleur", motor: "Motorisatie", installation: "Plaatsing toevoegen", previewHint: "Indicatieve foto van het geselecteerde product",
      name: "Naam en voornaam", phone: "Telefoon", email: "E-mail", postcode: "Postcode van de werf", message: "Aanvullende informatie",
      submit: "Nauwkeurige offerte aanvragen", privacy: "Door dit formulier te verzenden, gaat u ermee akkoord dat wij contact met u opnemen over uw project.",
      estimate: "Indicatieve raming", vatIncluded: "Incl. 21% btw", freeTransport: "Gratis transport in België",
      disclaimer: "Deze raming is geen bindende offerte. De definitieve prijs wordt bevestigd na technische controle en opmeting.",
      success: "Bedankt. Uw configuratie werd verzonden.", sliding: "Schuifpoort", double: "Dubbele draaipoort", wicket: "Looppoort",
      steel: "Staal", aluminium: "Aluminium", base: "Product", colourExtra: "Kleurtoeslag", automation: "Motorisatie", accessories: "Opties",
      transport: "Transport", free: "Gratis", installed: "Plaatsing", noMotor: "Zonder motorisatie", withMotorAwso: "Met motorisatie – AWso 2025 Pro", withMotorSomfy: "Met motorisatie – Somfy Ixengo L 3S io", standard: "Standaard RAL - inbegrepen",
      nonstandard: "Niet-standaard RAL (+10%)", special: "Speciale kleur (+15%)", home2: "Home Inclusive 2.0 (+15%)",
      extraRemote: "Extra afstandsbediening", reflectedCells: "Reflecterende fotocellen", gsm: "GSM 4G-bediening",
      gateWifi: "WIŚNIOWSKI GATE Wi-Fi-module", codeLock: "Codeklavier buiten", cardReader: "Proximity-kaartlezer",
      fingerprint: "BioKey-vingerafdruklezer", safetyEdge: "Veiligheidssysteem met contactlijst", magneticLock: "Elektromagnetisch slot",
      closer: "Hydraulische poortsluiter Locinox LION – automatische sluiting", electricLock: "Verticaal elektrisch BFT-slot",
      selectOption: "Selecteer", dimensionUnavailable: "Afmeting niet geprijsd - vraag een offerte", configuration: "Configuratie",
      installationIncluded: "Vaste prijs incl. btw", summaryProduct: "Product", summaryDimensions: "Afmetingen", summaryFinish: "Afwerking", summaryTotal: "Geschat totaal"
    }
  };

  var MOTORS = {
    sliding: [
      { id: "none", label: "noMotor", price: function () { return 0; }, remote: 0 },
      { id: "awso2025", label: "withMotorAwso", price: function (w) { return w <= 4500 ? 113740 : 118701; }, remote: 3388 }
    ],
    double: [
      { id: "none", label: "noMotor", price: function () { return 0; }, remote: 0, maxLeaf: 9999 },
      { id: "somfy-ixengo", label: "withMotorSomfy", price: function () { return 140602; }, remote: 7139, maxLeaf: 3000 }
    ],
    wicket: [{ id: "none", label: "noMotor", price: function () { return 0; }, remote: 0 }]
  };

  var FINISHES = [
    { id: "standard", label: "standard", rate: 0 },
    { id: "nonstandard", label: "nonstandard", rate: .10 },
    { id: "special", label: "special", rate: .15 },
    { id: "home2", label: "home2", rate: .15 }
  ];

  var OPTION_DEFS = [
    { id: "extraRemote", label: "extraRemote", products: ["sliding", "double"], motorOnly: true, price: function (s) { return currentMotor(s).remote || 0; } },
    { id: "reflectedCells", label: "reflectedCells", products: ["sliding", "double"], motorOnly: true, price: function () { return 22143; } },
    { id: "gsm", label: "gsm", products: ["sliding", "double"], motorOnly: true, price: function () { return 22748; } },
    { id: "gateWifi", label: "gateWifi", products: ["sliding", "double"], motorOnly: true, price: function () { return 9559; } },
    { id: "codeLock", label: "codeLock", products: ["sliding", "double"], motorOnly: true, price: function () { return 15972; } },
    { id: "cardReader", label: "cardReader", products: ["sliding", "double"], motorOnly: true, price: function () { return 15972; } },
    { id: "fingerprint", label: "fingerprint", products: ["sliding", "double"], motorOnly: true, price: function () { return 112409; } },
    { id: "safetyEdge", label: "safetyEdge", products: ["sliding"], motorOnly: true, price: function (s) { return 34606 + Math.round(16456 * (s.height / 1000)); } },
    { id: "magneticLock", label: "magneticLock", products: ["wicket"], price: function () { return 7381; } },
    { id: "closer", label: "closer", products: ["wicket"], price: function () { return 79860; } },
    { id: "electricLock", label: "electricLock", products: ["double"], motorOnly: true, price: function () { return 26741; } }
  ];

  function init(root) {
    var lang = (root.dataset.language || "fr").toLowerCase().slice(0, 2);
    if (!I18N[lang]) lang = "fr";
    var tx = I18N[lang];
    var locale = lang === "nl" ? "nl-BE" : "fr-BE";
    var money = new Intl.NumberFormat(locale, { style: "currency", currency: "EUR" });
    var state = { product: "sliding", material: "steel", system: "Classic", model: "", width: 0, height: 0, finish: "standard", motor: "none", selectedOptions: new Set(), installation: false };
    root._wcfgState = state;

    var el = {
      types: root.querySelector("[data-wcfg-types]"), material: root.querySelector("[data-wcfg-material]"), system: root.querySelector("[data-wcfg-system]"),
      model: root.querySelector("[data-wcfg-model]"), width: root.querySelector("[data-wcfg-width]"), height: root.querySelector("[data-wcfg-height]"),
      finish: root.querySelector("[data-wcfg-finish]"), motor: root.querySelector("[data-wcfg-motor]"), motorWrap: root.querySelector("[data-wcfg-motor-wrap]"),
      options: root.querySelector("[data-wcfg-options]"), installation: root.querySelector("[data-wcfg-installation]"), installationPrice: root.querySelector("[data-wcfg-installation-price]"),
      total: root.querySelector("[data-wcfg-total]"), breakdown: root.querySelector("[data-wcfg-breakdown]"), contactSummary: root.querySelector("[data-wcfg-contact-summary]"),
      preview: root.querySelector("[data-wcfg-preview]"), modelImage: root.querySelector("[data-wcfg-model-image]"), modelName: root.querySelector("[data-wcfg-model-name]"),
      layout: root.querySelector(".wcfg__layout"), summary: root.querySelector(".wcfg__summary"), mobileSummarySlot: root.querySelector("[data-wcfg-mobile-summary-slot]")
    };

    root.querySelectorAll("[data-i18n]").forEach(function (node) { var key = node.dataset.i18n; if (tx[key]) node.textContent = tx[key]; });
    var mobileSummaryMedia = window.matchMedia("(max-width: 900px)");
    placeSummary();
    if (mobileSummaryMedia.addEventListener) mobileSummaryMedia.addEventListener("change", placeSummary);
    else mobileSummaryMedia.addListener(placeSummary);
    renderTypes();
    populateFinish();
    syncProduct();

    el.material.addEventListener("change", function () { state.material = this.value; populateSystems(); });
    el.system.addEventListener("change", function () { state.system = this.value; populateModels(); });
    el.model.addEventListener("change", function () { state.model = this.value; populateWidths(); renderPreview(); });
    el.width.addEventListener("change", function () { state.width = Number(this.value); populateHeights(); populateMotors(); });
    el.height.addEventListener("change", function () { state.height = Number(this.value); renderOptions(); calculate(); });
    el.finish.addEventListener("change", function () { state.finish = this.value; calculate(); });
    el.motor.addEventListener("change", function () { state.motor = this.value; renderOptions(); calculate(); });
    el.installation.addEventListener("change", function () { state.installation = this.checked; calculate(); });
    var form = root.querySelector("form");
    if (form) form.addEventListener("submit", updateContactSummary);

    function renderTypes() {
      var images = {
        sliding: root.dataset.typeImageSliding,
        double: root.dataset.typeImageDouble,
        wicket: root.dataset.typeImageWicket
      };
      el.types.innerHTML = "";
      ["sliding", "double", "wicket"].forEach(function (type) {
        var button = document.createElement("button");
        button.type = "button";
        button.className = "wcfg__type" + (state.product === type ? " is-active" : "");
        button.dataset.product = type;
        var image = document.createElement("img");
        image.className = "wcfg__type-image";
        image.src = images[type];
        image.alt = "";
        image.width = 320;
        image.height = 180;
        image.decoding = "async";
        var label = document.createElement("span");
        label.className = "wcfg__type-label";
        label.textContent = tx[type];
        button.appendChild(image);
        button.appendChild(label);
        button.addEventListener("click", function () { state.product = type; state.selectedOptions.clear(); renderTypes(); syncProduct(); });
        el.types.appendChild(button);
      });
    }

    function placeSummary() {
      if (!el.summary || !el.layout || !el.mobileSummarySlot) return;
      if (mobileSummaryMedia.matches) {
        if (el.summary.parentNode !== el.mobileSummarySlot) el.mobileSummarySlot.appendChild(el.summary);
      } else if (el.summary.parentNode !== el.layout) {
        el.layout.appendChild(el.summary);
      }
    }

    function syncProduct() {
      var installation = DATA.installationTtc[state.product] || 0;
      el.installationPrice.textContent = tx.installationIncluded + " - " + money.format(installation);
      el.motorWrap.hidden = state.product === "wicket";
      populateMaterials();
    }

    function branch() {
      return (((DATA.prices[state.product] || {})[state.material] || {})[state.system] || {})[state.model] || [];
    }

    function option(select, value, label) {
      var node = document.createElement("option"); node.value = value; node.textContent = label; select.appendChild(node);
    }

    function populateMaterials() {
      var materials = Object.keys(DATA.prices[state.product] || {});
      el.material.innerHTML = "";
      materials.forEach(function (value) { option(el.material, value, tx[value] || value); });
      state.material = materials.indexOf(state.material) >= 0 ? state.material : materials[0];
      el.material.value = state.material;
      populateSystems();
    }

    function populateSystems() {
      var systems = Object.keys(((DATA.prices[state.product] || {})[state.material]) || {});
      el.system.innerHTML = "";
      systems.forEach(function (value) { option(el.system, value, value); });
      state.system = systems.indexOf(state.system) >= 0 ? state.system : systems[0];
      el.system.value = state.system;
      populateModels();
    }

    function populateModels() {
      var models = Object.keys((((DATA.prices[state.product] || {})[state.material] || {})[state.system]) || {});
      el.model.innerHTML = "";
      models.forEach(function (value) { option(el.model, value, value); });
      state.model = models.indexOf(state.model) >= 0 ? state.model : models[0];
      el.model.value = state.model;
      populateWidths(); renderPreview();
    }

    function populateWidths() {
      var widths = new Set();
      branch().forEach(function (rule) { rule[1].forEach(function (w) { widths.add(w); }); });
      var values = Array.from(widths).sort(function (a, b) { return a - b; });
      el.width.innerHTML = "";
      values.forEach(function (value) { option(el.width, value, (state.material === "aluminium" ? "≤ " : "") + value + " mm"); });
      state.width = values.indexOf(state.width) >= 0 ? state.width : values[0];
      el.width.value = state.width;
      populateHeights(); populateMotors();
    }

    function populateHeights() {
      var heights = new Set();
      branch().forEach(function (rule) { if (rule[1].indexOf(state.width) >= 0) rule[2].forEach(function (h) { heights.add(h); }); });
      var values = Array.from(heights).sort(function (a, b) { return a - b; });
      el.height.innerHTML = "";
      values.forEach(function (value) { option(el.height, value, (state.material === "aluminium" ? "≤ " : "") + value + " mm"); });
      state.height = values.indexOf(state.height) >= 0 ? state.height : values[0];
      el.height.value = state.height;
      renderOptions(); calculate();
    }

    function populateFinish() {
      el.finish.innerHTML = "";
      FINISHES.forEach(function (finish) { option(el.finish, finish.id, tx[finish.label]); });
      el.finish.value = state.finish;
    }

    function populateMotors() {
      var motors = availableMotors(state);
      el.motor.innerHTML = "";
      motors.forEach(function (motor) { option(el.motor, motor.id, motor.label ? tx[motor.label] : motor.name); });
      if (!motors.some(function (motor) { return motor.id === state.motor; })) state.motor = "none";
      el.motor.value = state.motor;
      renderOptions(); calculate();
    }

    function renderOptions() {
      var valid = OPTION_DEFS.filter(function (item) {
        return item.products.indexOf(state.product) >= 0 && (!item.motorOnly || state.motor !== "none");
      });
      var validIds = valid.map(function (item) { return item.id; });
      Array.from(state.selectedOptions).forEach(function (id) { if (validIds.indexOf(id) < 0) state.selectedOptions.delete(id); });
      el.options.innerHTML = "";
      valid.forEach(function (item) {
        var label = document.createElement("label"); label.className = "wcfg__check";
        var checkbox = document.createElement("input"); checkbox.type = "checkbox"; checkbox.checked = state.selectedOptions.has(item.id);
        checkbox.addEventListener("change", function () { if (this.checked) state.selectedOptions.add(item.id); else state.selectedOptions.delete(item.id); calculate(); });
        var copy = document.createElement("span"); copy.innerHTML = "<strong>" + tx[item.label] + "</strong>";
        var price = document.createElement("span"); price.className = "wcfg__check-price"; price.textContent = "+ " + money.format(item.price(state) / 100);
        label.appendChild(checkbox); label.appendChild(copy); label.appendChild(price); el.options.appendChild(label);
      });
    }

    function renderPreview() {
      var images = window.WISNIOWSKI_MODEL_IMAGES || {};
      var productImages = images[state.product] || {};
      var url = productImages[state.model];
      if (!url) { el.preview.hidden = true; return; }
      el.modelImage.src = url;
      el.modelImage.alt = tx[state.product] + " " + state.model;
      el.modelName.textContent = tx[state.product] + " · " + state.model;
      el.preview.dataset.product = state.product;
      el.preview.hidden = false;
    }

    function basePrice() {
      var rules = branch();
      for (var i = 0; i < rules.length; i += 1) {
        if (rules[i][1].indexOf(state.width) >= 0 && rules[i][2].indexOf(state.height) >= 0) return rules[i][0];
      }
      return 0;
    }

    function calculate() {
      var base = basePrice();
      var finish = FINISHES.find(function (item) { return item.id === state.finish; }) || FINISHES[0];
      var colour = Math.round(base * finish.rate);
      var motor = currentMotor(state); var motorPrice = state.product === "wicket" ? 0 : motor.price(state.width);
      var optionsPrice = 0;
      OPTION_DEFS.forEach(function (item) { if (state.selectedOptions.has(item.id)) optionsPrice += item.price(state); });
      var installation = state.installation ? Math.round((DATA.installationTtc[state.product] || 0) * 100) : 0;
      var total = base + colour + motorPrice + optionsPrice + installation;
      el.total.textContent = base ? money.format(total / 100) : "—";
      var lines = [
        [tx.base, base], [tx.colourExtra, colour], [tx.automation, motorPrice], [tx.accessories, optionsPrice],
        [tx.installed, installation], [tx.transport, tx.free]
      ];
      el.breakdown.innerHTML = lines.filter(function (line, index) { return index === 0 || index === 5 || line[1] > 0; }).map(function (line) {
        return "<dt>" + line[0] + "</dt><dd>" + (typeof line[1] === "number" ? money.format(line[1] / 100) : line[1]) + "</dd>";
      }).join("");
      updateContactSummary();
    }

    function updateContactSummary() {
      var base = basePrice();
      var finish = FINISHES.find(function (item) { return item.id === state.finish; }) || FINISHES[0];
      var colour = Math.round(base * finish.rate);
      var motor = currentMotor(state); var motorPrice = state.product === "wicket" ? 0 : motor.price(state.width);
      var selected = OPTION_DEFS.filter(function (item) { return state.selectedOptions.has(item.id); });
      var optionsPrice = selected.reduce(function (sum, item) { return sum + item.price(state); }, 0);
      var installation = state.installation ? Math.round((DATA.installationTtc[state.product] || 0) * 100) : 0;
      var total = base + colour + motorPrice + optionsPrice + installation;
      el.contactSummary.value = [
        tx.configuration + " WIŚNIOWSKI (tarif " + DATA.sourcePriceListDate + ")",
        tx.summaryProduct + ": " + tx[state.product] + " / " + tx[state.material] + " / " + state.system + " / " + state.model,
        tx.summaryDimensions + ": " + state.width + " x " + state.height + " mm",
        tx.summaryFinish + ": " + tx[finish.label],
        tx.automation + ": " + (motor.label ? tx[motor.label] : motor.name),
        tx.accessories + ": " + (selected.length ? selected.map(function (item) { return tx[item.label]; }).join(", ") : "—"),
        tx.installed + ": " + (state.installation ? money.format(installation / 100) : "—"),
        tx.transport + ": " + tx.free,
        tx.summaryTotal + ": " + (base ? money.format(total / 100) : tx.dimensionUnavailable)
      ].join("\n");
    }
  }

  function availableMotors(state) {
    return (MOTORS[state.product] || MOTORS.wicket).filter(function (motor) {
      return !motor.maxLeaf || state.width / 2 <= motor.maxLeaf;
    });
  }

  function currentMotor(state) {
    var motors = availableMotors(state);
    return motors.find(function (motor) { return motor.id === state.motor; }) || motors[0];
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-wcfg-root]").forEach(init);
  });
})();
